import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

import EditContactForm from './edit_contact_form';
import LoadingSpinner from 'components/loading_spinner';
import { updateCompany } from './companies/api';
import QuickNewContactForm from './quick_new_contact_form';
import { updatePerson } from './people/api';

export default class NewOrEditContactForm extends React.Component {
  static propTypes = {
    additionalFields: PropTypes.node,
    editProps: PropTypes.shape({
      contactId: PropTypes.number.isRequired,
      contactType: PropTypes.string.isRequired,
      hasCrm: PropTypes.bool
    }),
    newProps: PropTypes.shape({
      availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
      projectId: PropTypes.number
    }),
    showNewFormTypeSelector: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    contact: null,
    isLoading: true,
    isSaving: false,
    persistAddress: false
  }

  isValid() {
    const { contact, isLoading, isSaving } = this.state;

    return !(isLoading || isSaving) && contact && contact.name;
  }

  handleLoad = (contact, persistAddress) => {
    this.setState({
      contact,
      isLoading: false,
      persistAddress
    });
  }

  togglePersistAddress = () => {
    this.setState(prevState => ({ ...prevState, persistAddress: !prevState.persistAddress }));
  }

  handleChange = (contact, persistAddress = false) => {
    this.setState({ contact, persistAddress });
  }

  handleSave = () => {
    const { editProps, onSave } = this.props;
    const { contact } = this.state;
    let savePromise;

    if (!contact) {
      return;
    }

    this.setState({ isSaving: true });

    if (editProps.contactType === 'Contacts::Company') {
      savePromise = updateCompany(contact, this.state.persistAddress ? contact.address : null);
    } else {
      const contactFields = pick(
        contact,
        'id',
        'email',
        'firstName',
        'jobTitle',
        'lastName',
        'mobilePhoneNumber',
        'officePhoneNumber'
      );
      savePromise = updatePerson(contactFields);
    }

    savePromise.then((contact) => {
      onSave(contact);
      this.setState({ contact, isSaving: false });
    }).catch(() => {
      this.setState({ isSaving: false });
    });
  }

  render() {
    const { additionalFields, editProps, newProps, showNewFormTypeSelector, onCancel, onSave } = this.props;
    const { isLoading } = this.state;

    if (editProps) {
      return (
        <React.Fragment>
          {isLoading && <LoadingSpinner />}
          <EditContactForm
            additionalFields={additionalFields}
            hasCrm={editProps.hasCrm}
            id={editProps.contactId}
            persistAddress={this.state.persistAddress}
            type={editProps.contactType}
            onChange={this.handleChange}
            onLoad={this.handleLoad}
            onPersistChange={this.togglePersistAddress}
          />

          <hr />

          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-ghost" name="cancel" onClick={onCancel}>Cancel</button>
            <button className="btn btn-primary" disabled={!this.isValid()} name="save" onClick={this.handleSave}>
              {editProps.contactType === 'Contacts::Company' ? 'Save Company' : 'Save Contact'}
            </button>
          </div>
        </React.Fragment>
      );
    }

    return (
      <QuickNewContactForm
        additionalFields={additionalFields}
        availableDatabaseOptions={newProps.availableDatabaseOptions}
        personOrCompany={newProps.personOrCompany}
        projectId={newProps.projectId}
        showContactTypeSelector={showNewFormTypeSelector}
        onCancel={onCancel}
        onSave={onSave}
      />
    );
  }
}
